import { GiveawayDataTableFooter } from "@/components/DataTable/giveawayDataTableFooter";
import { GridPagination } from "@mui/x-data-grid";

export default function GiveawayFooter(props) {
  return (
    <>
      <GiveawayDataTableFooter {...props}></GiveawayDataTableFooter>
      <GridPagination></GridPagination>
    </>
  );
}
